export function setElementStyle(element: HTMLElement, style: Partial<CSSStyleDeclaration>) {
    Object.assign(element.style, style);
}
